import { Post } from '../Post';

import { SharedPostProps } from './SharedPost.interfaces';

export const SharedPost = ({ post }: SharedPostProps) => (
  <div className="c-post-share">
    <Post {...post} shouldHidePostOptions />
  </div>
);
